import { extractMentionedEntityIds } from './entity-mentions';

export interface ResourceEntityRef {
  sourceType: string;
  sourceId: string;
  targetType: string;
  targetId: string;
}

export function linkedEntityIdsForResource(
  resourceId: string,
  entityRefs: ResourceEntityRef[],
  notesHtml: string | null | undefined
): { characterIds: string[]; locationIds: string[] } {
  const characterIdsFromRefs = entityRefs
    .filter(
      (ref) =>
        ref.sourceType === 'resource' &&
        ref.sourceId === resourceId &&
        ref.targetType === 'character'
    )
    .map((ref) => ref.targetId);
  const locationIdsFromRefs = entityRefs
    .filter(
      (ref) =>
        ref.sourceType === 'resource' &&
        ref.sourceId === resourceId &&
        ref.targetType === 'location'
    )
    .map((ref) => ref.targetId);
  const notes = notesHtml ?? '';

  return {
    characterIds: Array.from(
      new Set([...characterIdsFromRefs, ...extractMentionedEntityIds(notes, 'character')])
    ),
    locationIds: Array.from(
      new Set([...locationIdsFromRefs, ...extractMentionedEntityIds(notes, 'location')])
    ),
  };
}
